import * as THREE from 'three';

let _cachedRenderer: THREE.WebGLRenderer | null = null;
let _cachedWidth = 0;
let _cachedHeight = 0;
let _cacheTime = 0;
const CACHE_TTL = 500;

export function setCanvasRenderer(renderer: THREE.WebGLRenderer): void {
    _cachedRenderer = renderer;
}

export function getCanvasResolution(renderer?: THREE.WebGLRenderer): { width: number; height: number } {
    const r = renderer || _cachedRenderer;
    if (r?.domElement) {
        const now = performance.now();
        if (now - _cacheTime > CACHE_TTL || renderer) {
            _cachedWidth = r.domElement.clientWidth || r.domElement.width;
            _cachedHeight = r.domElement.clientHeight || r.domElement.height;
            _cacheTime = now;
        }
        if (_cachedWidth > 0 && _cachedHeight > 0) {
            return { width: _cachedWidth, height: _cachedHeight };
        }
    }
    return { width: window.innerWidth, height: window.innerHeight };
}

export function getCanvasResolutionVec2(renderer?: THREE.WebGLRenderer): THREE.Vector2 {
    const { width, height } = getCanvasResolution(renderer);
    return new THREE.Vector2(width, height);
}
